import React from 'react';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import { menuAPI } from '../../InterfaceAPI/menuAPI';

export const ServiceCalendarContext = React.createContext({
  activeService: {},
  onServiceSelect: () => {},
  openModal: '',
  isLoadingActiveService: false,
  getServiceDetails: () => {},
  sendServiceDetailsEmail: () => {},
  handleSelectEvent: () => {},
  closeModal: () => {},
  sendDetailsAudience: 'client',
});

export const withServiceCalendar = (Component) => {
  return function withServiceCalendarContext(props) {
    return (
      <ServiceCalendarContext.Consumer>
        {(contextProps) => <Component {...props} {...contextProps} />}
      </ServiceCalendarContext.Consumer>
    );
  };
};

export class ServiceCalendarProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeService: {},
      onServiceSelect: this.onServiceSelect,
      openModal: '',
      isLoadingActiveService: false,
      getServiceDetails: this.getServiceDetails,
      handleSelectEvent: this.handleSelectEvent,
      closeModal: this.closeModal,
      sendServiceDetailsEmail: this.sendServiceDetailsEmail,
      sendDetailsAudience: 'client',
    };
  }

  closeModal = () => {
    this.setState({ openModal: '' });
  };

  onServiceSelect = (service) => {
    this.getServiceDetails(service);
  };

  sendServiceDetailsEmail = (service, audience) => {
    this.setState({
      openModal: 'send-details',
      activeService: service,
      sendDetailsAudience: audience,
    });
  };

  getServiceDetails = (service) => {
    this.setState({
      openModal: 'service-event',
      activeService: service,
      isLoadingActiveService: true,
    });

    serviceAPI
      .getService(service.id)
      .then(activeService => {
        this.setState({ activeService })

        // load dishes for each menu selection
        return Promise.all(activeService.menu_selections.map(sel => 
          new Promise((resolve, reject) => {
            menuAPI.getDish(sel.dish_id)
            .then(dish => resolve({ ...sel, dish }))
            .catch(error => { reject(error); console.log(error) })
          })
        ));
      }).then(menuSelections => {
        this.setState({ activeService: { ...this.state.activeService, menu_selections: menuSelections}, isLoadingActiveService: false })
      })
      .catch(error => console.log(error));
  };

  handleSelectEvent = ({ service }, e) => this.onServiceSelect(service);

  render() {
    return (
      <ServiceCalendarContext.Provider value={this.state}>
        {this.props.children}
      </ServiceCalendarContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/ServiceCalendarContext.js